<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import FontAwesomeView from "../Image/FontAwesomeView.svelte";
    import HoverTipsView from "../Message/HoverTipsView.svelte";
    import {ValueUtil} from "../../../lib/Common/Value/ValueUtil";

    const dispatcher = createEventDispatcher();

    export let text = '';
    export let isDisabled = false;
    export let isProgress = false;
    export let isPrimary = false;
    export let isDanger = false;
    export let isSmall = false;
    export let tipsMessage = null;

    export let width = null;

    export let fontAwesomeIcon = null;
    export let fontAwesomeClassification = null;

    export let isStopPropagation = true;

    $: style = (() => {
        const styleClass = [];
        if (width != null) {
            styleClass.push(`width: ${width}`);
        }
        const style = styleClass.join(';');
        return style;
    })();

    onMount(() => {


    });

    function onClick(event) {
        if (isStopPropagation) {
            event.stopPropagation();
        }

        dispatcher("click");
    }


</script>

<button class="button-view"
        disabled={isDisabled}
        class:progress={isProgress}
        class:primary={isPrimary}
        class:danger={isDanger}
        class:small={isSmall}
        style={style}
        on:click={onClick}
>

    <div class="frame">
    </div>

    <div class="text-area">
        <div class="text">
            {#if fontAwesomeIcon != null}
                <FontAwesomeView classification={fontAwesomeClassification} icon={fontAwesomeIcon}/>
            {/if}

            {text}

            {#if !ValueUtil.isEmpty(tipsMessage)}
                <HoverTipsView message={tipsMessage}/>
            {/if}

        </div>

        {#if isProgress }
            <div class="progress-area">
                <div class="progress-icon animation-loading-rotate">
                    <FontAwesomeView isEnablePaddingLeftRight={false} icon="spinner"/>
                </div>
            </div>
        {/if}
    </div>


</button>


<style lang="scss">
    .button-view {
        position: relative;
        transition-duration: 0.5s;


        border-color: rgba(0, 0, 0, 0.4);

        .frame {
            position: absolute;
            width: 120%;
            height: 120%;
            border-color: transparent;
            transition-duration: 0.25s;
            border-style: solid;
            pointer-events: none;
        }

        &:hover {
            .frame {
                border-color: #0003;
                width: 100%;
                height: 100%;

            }

            &.primary {
                .frame {
                    border-color: var(--button-primary-border-color);
                }
            }

            &.danger {
                .frame {
                    border-color: var(--button-danger-border-color);
                }
            }

            &.progress {
                .frame {
                    border-color: transparent;
                }
            }
        }


        .text-area {
            min-height: 1em;
        }


        &.progress {
            .text-area {
                position: relative;


                .text {
                    opacity: 0.1;
                }

                .progress-area {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5em;

                    .progress-icon {

                        display: inline-flex;
                    }
                }
            }


        }

        &:disabled {
            .frame {
                opacity: 0;
            }
        }

    }
</style>